/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

/* ------------------- UPLOAD EMPLOYEE IMAGE ------------------- */
export const uploadEmployeeImage = createAsyncThunk(
  "employeeImage/upload",
  async ({ employeeId, file }, { rejectWithValue }) => {
    try {
      // FIX: Check if 'file' is already a FormData object. 
      // If it is (which it is in your EmployeeDetails.js), send it directly.
      const payload = file instanceof FormData ? file : (() => {
        const fd = new FormData();
        fd.append("image", file);
        return fd;
      })();

      const response = await axios.post(
        `${API_URL}/employee-image/${employeeId}/upload`,
        payload, 
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      return response.data; 
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to upload image";
      return rejectWithValue(msg);
    }
  }
);

/* ------------------- GET EMPLOYEE IMAGE BY ID ------------------- */
export const fetchEmployeeImageById = createAsyncThunk(
  "employeeImage/fetchById",
  async (employeeId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${API_URL}/employee-image/${employeeId}`
      );
      return response.data; 
    } catch (err) {
      const msg = err.response?.data?.message || "Failed to fetch image";
      return rejectWithValue(msg);
    }
  }
);

/* ------------------- SLICE ------------------- */
const employeeImageSlice = createSlice({
  name: "employeeImage",
  initialState: {
    image: null,
    status: "idle",
    error: null,
  },
  reducers: {
    clearEmployeeImage: (state) => {
      state.image = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadEmployeeImage.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(uploadEmployeeImage.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.image = action.payload;
        state.error = null;
      })
      .addCase(uploadEmployeeImage.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(fetchEmployeeImageById.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchEmployeeImageById.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.image = action.payload;
        state.error = null;
      })
      .addCase(fetchEmployeeImageById.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearEmployeeImage } = employeeImageSlice.actions;
export default employeeImageSlice.reducer;